var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChromatoColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:currentColor;stroke-miterlimit:10;}\r\n\t.st1{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.9,64.3h2.2v2.1c0,0.4-0.3,0.6-0.6,0.6h-0.9c-0.4,0-0.6-0.3-0.6-0.6V64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,12.9h0.9c0.4,0,0.6,0.3,0.6,0.6v2.2h-2.2v-2.2C38.9,13.2,39.2,12.9,39.5,12.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.7,
    y: 20.6,
    className: "st1",
    width: 66.5,
    height: 38.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74,22.4H6v-5.1c0-1,0.8-1.8,1.8-1.8h64.4c1,0,1.8,0.8,1.8,1.8V22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,57.6h68v5.1c0,1-0.8,1.8-1.8,1.8H7.8c-1,0-1.8-0.8-1.8-1.8V57.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromatoColumn);
export default __webpack_public_path__ + "static/media/chromatoColumn.70ecc802fe0266d14721119343e6ce07.svg";
export { ForwardRef as ReactComponent };